import React, { Component } from 'react';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import applyDates from '../../../utils/applyDates';

class EditarFechas extends Component {
  constructor(props) {
    super(props);

    const pedidos = _.filter(this.props.pedidos, _.property(this.props.numProfVeh)
                            )[0][this.props.numProfVeh];

    const fechas = {};
    pedidos.forEach((pedido) => {
      Object.assign(fechas, { [pedido.numPedidoVeh]: ['', '', ''] });
    });

    this.state = {
      fechas,
    };
  }

  changeDate = (date, pedido, index) => {
    const { fechas } = this.state;
    fechas[pedido][index] = date;
    this.setState({ fechas });
  }

  aplicar = () => {
    const pedidos = _.filter(this.props.pedidos, _.property(this.props.numProfVeh)
                            )[0][this.props.numProfVeh];

    pedidos.map(pedido => (
      applyDates(this.state.fechas[pedido.numPedidoVeh])
    ));
  }

  render() {
    if (this.props.pedidos.length === 0) return null;
    const pedidos = _.filter(this.props.pedidos, _.property(this.props.numProfVeh)
                            )[0][this.props.numProfVeh];

    return (
      <div>
        <div className='row fdv-pedidos-editDates mb-2'>
          <div className='pull-right'>
            <button className='btn btn-default btn-sm' onClick={this.props.closeEdit}>Cancelar</button>
            <button className='btn btn-blue btn-sm' onClick={this.aplicar}>Aplicar fechas</button>
          </div>
        </div>
        <div className='tab-pane' id='editarfechas'>
          <div className='hidden-xs'>
            <div className='tableWrapper'>
              <table className='table table-hover'>
                <thead className='table-head'>
                  <tr>
                    <th rowSpan='2'>
                      <div className='checkbox checkbox-inline'>
                        <label>
                          <input type='checkbox' />
                          <div className='checkbox-skin' />
                        </label>
                      </div>
                    </th>
                    <th rowSpan='2'>Nº Pedido</th>
                    <th rowSpan='2'>Estado</th>
                    <th>F° Carrocero</th>
                    <th>F° PDI</th>
                    <th>F° Entrega</th>
                  </tr>
                  <tr>
                    <th>Inicial</th>
                    <th>Inicial</th>
                    <th>Inicial</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    pedidos.map(pedido =>
                      <tr>
                        <td>
                          <div className='checkbox checkbox-inline'>
                            <label htmlFor={`${pedido.numPedidoVeh}-pedidos`}>
                              <input
                                type='checkbox'
                                checked={this.props.pedidosConCheck.indexOf(pedido.numPedidoVeh)>=0}
                                onChange={() => this.props.selectCheckPedidos(pedido.numPedidoVeh)}
                                id={`${pedido.numPedidoVeh}-pedidos`}
                              />
                              <div className='checkbox-skin' />
                            </label>
                          </div>
                        </td>
                        <td>{pedido.numPedidoVeh}</td>
                        <td><span className='pill pill-block pill-yellow'>{pedido.estadoPedido}</span></td>
                        <td>
                          <DatePicker
                            selected={this.state.fechas[pedido.numPedidoVeh][0]}
                            className='form-control fSearch-search date-picker'
                            dateFormat='DD/MM/YYYY'
                            locale='es'
                            onChange={e => this.changeDate(e, pedido.numPedidoVeh, 0)}
                            placeholderText='Fecha estimada'
                          />
                        </td>
                        <td>
                          <DatePicker
                            selected={this.state.fechas[pedido.numPedidoVeh][1]}
                            className='form-control fSearch-search date-picker'
                            dateFormat='DD/MM/YYYY'
                            locale='es'
                            onChange={e => this.changeDate(e, pedido.numPedidoVeh, 1)}
                            placeholderText='Fecha estimada'
                          />
                        </td>
                        <td>
                          <DatePicker
                            selected={this.state.fechas[pedido.numPedidoVeh][2]}
                            className='form-control fSearch-search date-picker'
                            dateFormat='DD/MM/YYYY'
                            locale='es'
                            onChange={e => this.changeDate(e, pedido.numPedidoVeh, 2)}
                            placeholderText='Fecha estimada'
                          />
                        </td>
                      </tr>
                    )
                  }
                </tbody>
              </table>
            </div>
          </div>
          <div className='visible-xs'>
            <div className='tableMob'>
              <div className='tableMob-mainContent'>
                <div className='tableMob-header'>
                  <div className='tableMob-check'>
                    <div className='checkbox'>
                      <label>
                        <input type='checkbox' />
                        <div className='checkbox-skin' />
                      </label>
                    </div>
                  </div>
                  <h3 className='tableMob-title'>Pedido N° 12323</h3>
                </div>
                <ul className='tableMob-content row'>
                  <li className='tableMob-content-item col-xs-6'>
                    <p className='labelInfo'>Estado</p>
                    <div className='datepicker'>
                      <div className='datepicker-control'>
                        <input className='datepicker-field form-control ng-pristine ng-untouched ng-valid ng-isolate-scope' date-range-picker='' ng-model='date' options="{locale:{format: 'DD/MM/YYYY'},singleDatePicker: true}" name='pckr1' />
                        <div className='datepicker-trigger'><i className='ion-calendar' /></div>
                      </div>
                      <label className='error' generated='true' htmlFor='pckr1' />
                    </div>
                  </li>
                  <li className='tableMob-content-item col-xs-6'>
                    <p className='labelInfo'>F° Carrocero</p>
                    <div className='datepicker'>
                      <div className='datepicker-control'>
                        <input className='datepicker-field form-control ng-pristine ng-untouched ng-valid ng-isolate-scope' date-range-picker='' ng-model='date' options="{locale:{format: 'DD/MM/YYYY'},singleDatePicker: true}" name='pckr1' />
                        <div className='datepicker-trigger'><i className='ion-calendar' /></div>
                      </div>
                      <label className='error' generated='true' htmlFor='pckr1' />
                    </div>
                  </li>
                  <li className='tableMob-content-item col-xs-6'>
                    <p className='labelInfo'>F° Logística</p>
                    <div className='datepicker'>
                      <div className='datepicker-control'>
                        <input className='datepicker-field form-control ng-pristine ng-untouched ng-valid ng-isolate-scope' date-range-picker='' ng-model='date' options="{locale:{format: 'DD/MM/YYYY'},singleDatePicker: true}" name='pckr1' />
                        <div className='datepicker-trigger'><i className='ion-calendar' /></div>
                      </div>
                      <label className='error' generated='true' htmlFor='pckr1' />
                    </div>
                  </li>
                  <li className='tableMob-content-item col-xs-6'>
                    <p className='labelInfo'>F° Entrega</p>
                    <div className='datepicker'>
                      <div className='datepicker-control'>
                        <input className='datepicker-field form-control ng-pristine ng-untouched ng-valid ng-isolate-scope' date-range-picker='' ng-model='date' options="{locale:{format: 'DD/MM/YYYY'},singleDatePicker: true}" name='pckr1' />
                        <div className='datepicker-trigger'><i className='ion-calendar' /></div>
                      </div>
                      <label className='error' generated='true' htmlFor='pckr1' />
                    </div>
                  </li>
                </ul>
              </div>
              <div className='tableMob-extraContent collapse' />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EditarFechas;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/ContenidoTablas/EditarFechas.js